import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchGuestVisitTrack } from '../../../sagas/routines';

const initialState = {
  data: null,
  fetching: false,
  fetched: false
};

const fetchHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchHandler(fetchGuestVisitTrack)
});
